import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import { PropertyInterface } from "../../Entity/Entities/Property/PropertyInterface";
import Constants from "../../Action/Constants";

class PropertyUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id: number = parseInt(this.component.props.params.id, 10);
    const property: PropertyInterface = this.component.props.properties.byId[id];

    if (!!property) {
      return this.component.initializePage(property);
    } else {
      this.component.props.dispatch({
        type: Constants.GLOBAL_PROPERTY_FOR_PROPERTY_DETAILS_PAGE,
        payload: {
          propertyId: id,
        },
        onSuccess: (property: PropertyInterface) => {
          return this.component.initializePage(property); 
        },
        onError: this.component.redirectBack
      });
    }
  }
}

export default new PropertyUpdateWillMount();
